import BaseService from '../BaseService'

export default class FileUploadService extends BaseService {

  constructor() {
    super('docs')
  }

}
